// extracted by mini-css-extract-plugin
export default {"root":"ygRmxj","margin-top":"tOeDi9","marginTop":"tOeDi9","grid":"ZcJpug","header-cell":"gbGojl","headerCell":"gbGojl"};